var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',[(_vm.isLoadingInitialContentsContracts)?_c('div',{staticClass:"p-1 text-center border"},[_c('b-spinner'),_vm._v(" "),_c('br'),_vm._v(" Cargando módulo")],1):_c('Contracts')],1)}
var staticRenderFns = []

export { render, staticRenderFns }